@if (isVisible) {
  <div class="unified-panel">
    <div class="flex justify-content-between align-items-center p-3 border-bottom-1 surface-border bg-gray-50">
      <div class="flex align-items-center gap-2">
        <i class="pi pi-robot text-primary text-lg"></i>
        <h3 class="text-lg font-semibold text-900 m-0">{{ 'chat.threads.ai-workspace' | translate }}</h3>
      </div>
      <div class="flex align-items-center gap-2">
        <p-button
          icon="pi pi-plus"
          (onClick)="showNewThreadDialog()"
          [pTooltip]="'chat.threads.new-conversation' | translate"
          [text]="true"
          size="small"
          class="text-primary">
        </p-button>
        <p-button
          icon="pi pi-times"
          (onClick)="toggleVisibility()"
          [pTooltip]="'chat.threads.close-panel' | translate"
          [text]="true"
          class="text-gray-600">
        </p-button>
      </div>
    </div>

    <div class="panel-content">
      @if (!isAgentHealthy) {
        <div class="p-3">
          <p-message
            severity="error"
            class="w-full">
            <ng-template pTemplate="content">
              <div class="flex align-items-start gap-3">
                <i class="pi pi-exclamation-triangle text-lg mt-1"></i>
                <div class="flex-1">
                  <h5 class="text-sm font-semibold text-red-800 m-0 mb-1">{{ 'chat.threads.backend-unavailable' | translate }}</h5>
                  <p class="text-xs text-red-700 mb-3 line-height-3">{{ 'chat.threads.agent-services-offline' | translate }}</p>
                  <p-button
                    icon="pi pi-refresh"
                    [label]="'chat.threads.retry' | translate"
                    (onClick)="refreshAgents()"
                    [disabled]="isLoadingAgents"
                    severity="danger"
                    size="small"
                    [loading]="isLoadingAgents">
                  </p-button>
                </div>
              </div>
            </ng-template>
          </p-message>
        </div>
      } @else {
        <div class="threads-section p-3">
          <div class="flex justify-content-between align-items-center mb-3">
            <div class="flex align-items-center gap-2">
              <h4 class="text-base font-semibold text-900 m-0">{{ 'chat.threads.conversations' | translate }}</h4>
              <p-tag
                *ngIf="(threads$ | async)?.length > 0"
                [value]="(threads$ | async)?.length?.toString() || '0'"
                severity="info"
                class="text-xs">
              </p-tag>
            </div>
            <p-tag
              [value]="isAgentHealthy ? ('chat.threads.ready' | translate) : ('chat.threads.unavailable' | translate)"
              [severity]="isAgentHealthy ? 'success' : 'danger'"
              [icon]="isAgentHealthy ? 'pi pi-check' : 'pi pi-exclamation-triangle'"
              class="text-xs">
            </p-tag>
          </div>

          @if (isLoadingAgents) {
            <div class="flex align-items-center gap-2 p-3 text-center">
              <i class="pi pi-spin pi-spinner text-primary"></i>
              <span class="text-sm text-600">{{ 'chat.threads.loading-agents' | translate }}</span>
            </div>
          } @else {
            @if ((threads$ | async)?.length > 0) {
              <div class="threads-list max-h-20rem overflow-y-auto">
                @for (thread of threads$ | async; track $index) {
                  <div
                    class="thread-item p-3 border-round cursor-pointer hover:surface-100 transition-colors transition-duration-150"
                    [class.surface-200]="currentThread?.id === thread.id"
                    (click)="selectThread(thread)">
                    <div class="flex align-items-center justify-content-between w-full">
                      <div class="flex align-items-center gap-2">
                        <i class="pi pi-comments text-primary"></i>
                        <span class="text-sm text-700 flex-1">
                          {{ getThreadDisplayTitle(thread) }}
                        </span>
                      </div>
                      <p-button
                        icon="pi pi-trash"
                        (onClick)="deleteThread(thread, $event)"
                        [pTooltip]="'chat.threads.delete' | translate"
                        [text]="true"
                        size="small"
                        severity="danger"
                        class="text-red-600 hover:bg-red-100">
                      </p-button>
                    </div>
                  </div>
                }
              </div>
            } @else {
              <div class="text-center p-4">
                <i class="pi pi-comments text-4xl text-500 mb-3 block"></i>
                <p class="text-sm text-600 mb-4">{{ 'chat.threads.no-conversations' | translate }}</p>
                <p-button
                  icon="pi pi-plus"
                  [label]="'chat.threads.start-conversation' | translate"
                  (onClick)="showNewThreadDialog()"
                  class="text-primary">
                </p-button>
              </div>
            }
          }
        </div>
      }
    </div>
  </div>
}
